export default "__VITE_ASSET__KkSCYdGZ__"